import React, { useCallback, useState } from 'react';

import { View } from 'react-native';

import { useTranslation } from 'react-i18next';

import { LANGUAGE_KEYS } from 'config/languageKeys';
import { ADD_PROFILE_NAME } from 'config/testID';

import { isTabletOrWeb } from 'utils/responsiveness';

import CredentialInput from 'components/CredentialInput';

import styles from './styles';

const {
    PROFILE: { PROFILE_NAME_HINT_TEXT },
    ACCESSIBILITY: {
        PROFILE: { ACCESSIBILITY_PROFILE_EDIT_PROFILE_NAME },
    },
} = LANGUAGE_KEYS;

type Props = {
    text: string;
    profileNameErrorText: string;
    errorColor?: string;
    onEndEditing: () => void;
    onChangeText: (text: string) => void;
};

function ProfileNameInput({
    text,
    profileNameErrorText,
    errorColor,
    onEndEditing,
    onChangeText,
}: Props) {
    const { t } = useTranslation();

    const [inputValue, setInputValue] = useState(text);

    const handleChangeText = useCallback(
        (value: string) => {
            setInputValue(value);
            onChangeText(value);
        },
        [onChangeText],
    );

    return (
        <View style={styles.container}>
            <CredentialInput
                text={inputValue}
                testID={ADD_PROFILE_NAME}
                placeholder={PROFILE_NAME_HINT_TEXT}
                autoCorrect={false}
                autoCapitalize="none"
                autoComplete="off"
                errorText={profileNameErrorText}
                errorColor={errorColor}
                onEndEditing={onEndEditing}
                onChangeText={handleChangeText}
                maxLength={15}
                errorStyle={styles.errorInput}
                style={isTabletOrWeb ? styles.inputContainer : undefined}
                accessibilityLabel={t(ACCESSIBILITY_PROFILE_EDIT_PROFILE_NAME)}
            />
        </View>
    );
}

export default ProfileNameInput;
